import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { TableDesktopComponent } from '@beego/ngx-table';
import { TypeTableFactory } from '@internal-factories/tables/type-table.factory';
import { QuestionCategoriesController } from '../question-categories.controller';
import { UserPermissions } from '@shared-libs/enums';

@Component({
	selector: 'question-categories-desktop-component',
	templateUrl: 'question-categories.desktop.component.html',
	styleUrls: ['./question-categories.desktop.component.scss'],
})
export class QuestionCategoriesDesktopComponent implements AfterViewInit {
	@ViewChild(TableDesktopComponent) private readonly tableComponent: TableDesktopComponent;
	public readonly tableHeaders = TypeTableFactory.getHeaders();
	public readonly UserPermissions: typeof UserPermissions = UserPermissions;

	constructor(public readonly controller: QuestionCategoriesController) {}

	public ngAfterViewInit(): void {
		this.controller.tableComponent = this.tableComponent;
	}
}
